$(function() {
    if ($('.form-item-wrap--autosize').length) {
        $('.form-item-wrap--autosize').on('input change', function() {
            const $formItem = $(this).find('.form-item');
            const initialHeight = $formItem.data('initialHeight');

            if (!initialHeight) {
                $formItem.data('initialHeight', $formItem[0].scrollHeight);
            }

            setTimeout(function() {
                $formItem.css('height', 'auto');

                /**
                 * Fix for long placeholder bug in chrome
                 */
                if (
                    $formItem[0].scrollHeight > initialHeight &&
                    Boolean($formItem.val()) === false
                ) {
                    return void 0;
                }

                $formItem.css('height', $formItem[0].scrollHeight + 'px');
            }, 0);
        });

        $('.form-item-wrap--autosize').on('keydown keypress', function(e) {
            if (e.which == 13) e.preventDefault();
        });
    }
});

$(function() {
    if ($('.js-textarea-autosize').length) {
        function getScrollHeight(elm) {
            var savedValue = elm.value;
            elm.value = '';
            elm._baseScrollHeight = elm.scrollHeight;
            elm.value = savedValue;
        }

        function onExpandableTextareaInput({ target: elm }) {
            // make sure the input event originated from a textarea and it's desired to be auto-expandable
            if (!elm.classList.contains('js-textarea-autosize') ||
                !elm.nodeName == 'TEXTAREA'
            )
                return;
            var minRows = elm.getAttribute('data-min-rows') | 0,
                rows;
            !elm._baseScrollHeight && getScrollHeight(elm);
            elm.rows = minRows;
            rows = Math.ceil((elm.scrollHeight - elm._baseScrollHeight) / 24);
            elm.rows = minRows + rows;
        }
        // global delegated event listener
        document.addEventListener('input', onExpandableTextareaInput);
        document.addEventListener('click', function() {
            let textarea = $('.js-textarea-autosize');
            textarea.each(function() {
                onExpandableTextareaInput({ target: this });
            });
        })
    }
});